var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(NaN, NaN, NaN, 0)",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: 1365,
    height: 663,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1365 663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(682.5,331.5) scale(-1,1) translate(-682.5,-331.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.6631362611916807",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74adea",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74adea",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.6631362611916807)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0L 0 559.9223100514669Q 136.5 336.65517051388554  273 318.22251446676427T 546 47.2912908478454T 819 -148.94276554386215T 1092 -396.9034132032955T 1365 -684.5027470473215L 1365 0 Z;M0 0L 0 586.6461878446465Q 136.5 315.66264829354407  273 287.15051147877335T 546 3.9047281509398317T 819 -237.92270254938978T 1092 -481.30968729501615T 1365 -673.0105871989228L 1365 0 Z;M0 0L 0 624.2909920919839Q 136.5 325.05798837385674  273 277.5198847782015T 546 32.10667040191208T 819 -288.22974090841785T 1092 -580.5823458366326T 1365 -853.5659651883287L 1365 0 Z;M0 0L 0 559.9223100514669Q 136.5 336.65517051388554  273 318.22251446676427T 546 47.2912908478454T 819 -148.94276554386215T 1092 -396.9034132032955T 1365 -684.5027470473215L 1365 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.6631362611916807)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-2s",
    values: "M0 0L 0 589.5394802991765Q 136.5 354.36164952962383  273 319.1372009327773T 546 21.063905353150744T 819 -175.12681306987065T 1092 -556.1322649140673T 1365 -779.1819292877302L 1365 0 Z;M0 0L 0 647.524492107181Q 136.5 327.0758494736482  273 304.4527536429408T 546 90.92018734561043T 819 -310.8385266741815T 1092 -579.2008970371268T 1365 -774.1211629188567L 1365 0 Z;M0 0L 0 552.9895091807713Q 136.5 366.756858214797  273 320.1148093025025T 546 116.68392374027513T 819 -167.28293614044105T 1092 -388.7190565643623T 1365 -553.8378311355892L 1365 0 Z;M0 0L 0 589.5394802991765Q 136.5 354.36164952962383  273 319.1372009327773T 546 21.063905353150744T 819 -175.12681306987065T 1092 -556.1322649140673T 1365 -779.1819292877302L 1365 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.6631362611916807)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-4s",
    values: "M0 0L 0 558.5975923136798Q 136.5 376.39299825262304  273 350.06527271595735T 546 72.17301443382678T 819 -234.32733522998456T 1092 -390.2473565654252T 1365 -751.7196756057401L 1365 0 Z;M0 0L 0 649.0279097186168Q 136.5 322.0308713563925  273 296.6377607934784T 546 14.422344906733883T 819 -201.32078321763743T 1092 -473.09198954336T 1365 -815.101156947596L 1365 0 Z;M0 0L 0 556.2055158798348Q 136.5 383.2308126662065  273 352.14529058662174T 546 30.934860041351158T 819 -245.59142026143854T 1092 -540.0618089377014T 1365 -850.0255559086257L 1365 0 Z;M0 0L 0 558.5975923136798Q 136.5 376.39299825262304  273 350.06527271595735T 546 72.17301443382678T 819 -234.32733522998456T 1092 -390.2473565654252T 1365 -751.7196756057401L 1365 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.6631362611916807)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-6s",
    values: "M0 0L 0 596.1357246834037Q 136.5 383.32931014780905  273 350.33911127686883T 546 98.26679495021847T 819 -176.19273460867817T 1092 -482.5178323276118T 1365 -659.9901735187804L 1365 0 Z;M0 0L 0 623.2664357521724Q 136.5 344.91777003926427  273 325.23681979986793T 546 63.829592794410246T 819 -220.30845014426598T 1092 -538.3860140423523T 1365 -852.2510715122047L 1365 0 Z;M0 0L 0 565.4622161881915Q 136.5 301.81225480483863  273 275.687459761425T 546 36.49355520981976T 819 -244.60571203627921T 1092 -535.7521799839398T 1365 -799.6268875066908L 1365 0 Z;M0 0L 0 596.1357246834037Q 136.5 383.32931014780905  273 350.33911127686883T 546 98.26679495021847T 819 -176.19273460867817T 1092 -482.5178323276118T 1365 -659.9901735187804L 1365 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.6631362611916807)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-8s",
    values: "M0 0L 0 602.9873298720091Q 136.5 359.72771037015355  273 322.9100915015274T 546 47.016776690301526T 819 -237.90614591577844T 1092 -548.7264525058876T 1365 -750.7307584827223L 1365 0 Z;M0 0L 0 588.6805903089576Q 136.5 436.73411247654104  273 422.85921628356436T 546 164.03966063289363T 819 -121.50406130692727T 1092 -358.24304288757844T 1365 -625.0060986006332L 1365 0 Z;M0 0L 0 617.2567617373447Q 136.5 419.59339881784325  273 397.00088440832224T 546 99.01695458079877T 819 -192.91566267278893T 1092 -422.01272061423094T 1365 -644.8936538950059L 1365 0 Z;M0 0L 0 602.9873298720091Q 136.5 359.72771037015355  273 322.9100915015274T 546 47.016776690301526T 819 -237.90614591577844T 1092 -548.7264525058876T 1365 -750.7307584827223L 1365 0 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner02);
export default __webpack_public_path__ + "static/media/banner02.2f6ba07c3ed4697086f7b5173317ed7d.svg";
export { ForwardRef as ReactComponent };